var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{mobile:_vm.$vuetify.breakpoint.xs},attrs:{"id":"themes_top"}},[_c('ThemesBar'),(_vm.current || _vm.themes[0])?_c('TaskView',{staticClass:"task-view",class:{mobile:_vm.$vuetify.breakpoint.xs}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }